import { request as getRequest } from './reducers/get';
import { request as createRequest } from './reducers/create';
import { request as deleteRequest } from './reducers/delete';
import { request as updateRequest } from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default {
    ROLE_GET_REQUEST: getRequest,
    ROLE_CREATE_REQUEST: createRequest,
    ROLE_DELETE_REQUEST: deleteRequest,
    ROLE_UPDATE_REQUEST: updateRequest,
};
